<template>
  <div class="notification-element">
    <div class="notification-header">
      <span class="notification-type-badge">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
        <span>Notification</span>
      </span>
      <div class="element-actions">
        <button class="action-btn" @click.stop="$emit('duplicate')" title="Dupliquer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
        </button>
        <button class="action-btn delete-btn" @click.stop="$emit('remove')" title="Supprimer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
        </button>
      </div>
    </div>
    
    <!-- Mode Affichage -->
    <div v-if="!isEditing" class="notification-content" @click="startEditing">
      <div class="notification-recipient">
        <span class="recipient-label">Destinataire:</span>
        <span class="recipient-value">{{ element.to || 'Non défini' }}</span>
      </div>
      
      <div class="notification-type">
        <span class="type-label">Type:</span>
        <span class="type-value">{{ notificationType }}</span>
      </div>
      
      <div class="notification-message">
        <span class="message-label">Message:</span>
        <p class="message-value">{{ notificationMessage }}</p>
      </div>
      
      <div class="notification-preview" v-if="hasPreviewUrl">
        <span class="preview-label">Aperçu URL:</span>
        <span class="preview-value">Activé</span>
      </div>
      
      <div class="edit-button">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
        </svg>
        <span>Modifier</span>
      </div>
    </div>

    <!-- Mode Édition -->
    <div v-else class="notification-edit-form">
      <div class="form-group">
        <label>Destinataire (Numéro)</label>
        <input 
          type="text" 
          v-model="localElement.to" 
          placeholder="ex: 2217XXXXXXXX"
          class="form-input"
        >
      </div>

      <div class="form-group">
        <label>Type</label>
        <select v-model="localElement.notification.type" class="form-select">
          <option value="text">Texte</option>
          <option value="template">Template</option>
          <option value="image">Image</option>
        </select>
      </div>

      <div class="form-group">
        <label>Message</label>
        <textarea 
          v-model="localElement.notification.message" 
          placeholder="Votre message de notification..."
          class="form-textarea"
          rows="3"
        ></textarea>
      </div>

      <div class="form-group checkbox-group">
        <label class="checkbox-label">
          <input 
            type="checkbox" 
            v-model="localElement.notification.preview_url"
          >
          Activer l'aperçu URL
        </label>
      </div>

      <div class="edit-actions">
        <button class="cancel-btn" @click.stop="cancelEditing">Annuler</button>
        <button class="save-btn" @click.stop="saveChanges">Enregistrer</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationElement',
  props: {
    element: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isEditing: false,
      localElement: null
    };
  },
  created() {
    // Initialiser localElement avec une copie profonde de l'élément prop
    this.initLocalData();
  },
  watch: {
    element: {
      handler() {
        if (!this.isEditing) {
          this.initLocalData();
        }
      },
      deep: true
    }
  },
  computed: {
    notificationType() {
      if (this.element.notification && this.element.notification.type) {
        return this.element.notification.type;
      }
      return 'text';
    },
    notificationMessage() {
      if (this.element.notification && this.element.notification.message) {
        return this.element.notification.message;
      }
      return 'Aucun message';
    },
    hasPreviewUrl() {
      return this.element.notification && this.element.notification.preview_url === true;
    }
  },
  methods: {
    initLocalData() {
      // Copie défensive de l'élément pour éviter de muter la prop directement
      this.localElement = JSON.parse(JSON.stringify(this.element));
      
      // S'assurer que la structure notification existe
      if (!this.localElement.notification) {
        this.localElement.notification = {
          type: 'text',
          message: '',
          preview_url: true
        };
      }
    },
    startEditing() {
      this.initLocalData();
      this.isEditing = true;
    },
    cancelEditing() {
      this.isEditing = false;
      this.initLocalData(); // Revenir aux données originales
    },
    saveChanges() {
      // Émettre l'événement update avec les nouvelles données
      this.$emit('update', this.localElement);
      this.isEditing = false;
      
      this.$emit('notification', {
        message: 'Notification mise à jour',
        type: 'success'
      });
    }
  }
}
</script>

<style scoped>
.notification-element {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(249, 250, 251, 0.9));
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: all 0.2s ease;
}

.notification-element:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: linear-gradient(145deg, rgba(249, 250, 251, 0.8), rgba(243, 244, 246, 0.6));
  border-bottom: 1px solid rgba(229, 231, 235, 0.5);
}

.notification-type-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #6b7280;
  font-size: 0.875rem;
}

.notification-type-badge svg {
  color: #6b7280;
}

.element-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.9), rgba(249, 250, 251, 0.8));
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.action-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn.delete-btn:hover {
  background: linear-gradient(145deg, rgba(239, 68, 68, 0.15), rgba(239, 68, 68, 0.05));
  color: #ef4444;
}

.notification-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
}

.notification-edit-form {
  padding: 16px;
  background: rgba(255, 255, 255, 0.5);
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.form-input, .form-select, .form-textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.9rem;
  color: #1f2937;
  background: white;
  transition: all 0.2s;
}

.form-input:focus, .form-select:focus, .form-textarea:focus {
  outline: none;
  border-color: #9ca3af;
  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.1);
}

.checkbox-group {
  display: flex;
  align-items: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #374151;
  cursor: pointer;
}

.notification-recipient, .notification-type, .notification-preview {
  display: flex;
  align-items: center;
  gap: 8px;
}

.recipient-label, .type-label, .message-label, .preview-label {
  font-weight: 600;
  color: #4b5563;
  font-size: 0.85rem;
  min-width: 100px;
}

.recipient-value, .type-value, .preview-value {
  background: rgba(243, 244, 246, 0.8);
  color: #1f2937;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.85rem;
  border: 1px solid #e5e7eb;
}

.notification-message {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.message-value {
  background: rgba(243, 244, 246, 0.5);
  color: #374151;
  padding: 12px;
  border-radius: 8px;
  font-size: 0.9rem;
  margin: 0;
  border: 1px solid #e5e7eb;
  min-height: 60px;
  white-space: pre-wrap;
  line-height: 1.5;
}

.edit-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  color: #6b7280;
  font-size: 0.85rem;
  transition: all 0.2s ease;
  align-self: flex-end;
  margin-top: 8px;
  cursor: pointer;
}

.edit-button:hover {
  background: #f9fafb;
  color: #374151;
  border-color: #d1d5db;
}

.edit-actions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.save-btn, .cancel-btn {
  flex: 1;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.save-btn {
  background: #10b981;
  color: white;
  border: none;
}

.save-btn:hover {
  background: #059669;
}

.cancel-btn {
  background: white;
  color: #6b7280;
  border: 1px solid #e5e7eb;
}

.cancel-btn:hover {
  background: #f3f4f6;
  color: #374151;
}
</style>
